import React from "react";
import ContentLoader from "react-content-loader"

import { WrapperLoader } from "./styles";

function ProductLoader(props) {
    return (
        <WrapperLoader>
            <ContentLoader
                speed={1}
                viewBox="0 0 183 261"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                <rect x="0" y="0" rx="2" ry="2" width="186" height="133" />
                <rect x="10" y="140" rx="2" ry="2" width="100" height="10" />
                <rect x="10" y="156" rx="2" ry="2" width="30" height="5" />
                <rect x="10" y="170" rx="2" ry="2" width="140" height="6" />
            </ContentLoader>
        </WrapperLoader>
    )
}

export default ProductLoader;